export { default as MentionsPlugin } from './MentionsPlugin';
